import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { useLocation, useHistory } from 'react-router-dom';
import { Dropdown, Divider, Label, Icon } from 'semantic-ui-react';
import queryString from 'query-string';
import { toDropDownOptions } from 'utils/dropdownOptions';

import './FilterTransactions.scss';

const FilterTransactions = ({ onFilterTransactions, options }) => {
  let urlQueries = '';
  const { push } = useHistory();
  const location = useLocation();
  const queries = queryString.parse(location.search);
  const [filteredStatus, setFilteredStatus] = useState();

  const updateUrl = value => {
    Object.keys(queries || {}).forEach(key => {
      if (key && queries[key] && key !== 'status') {
        urlQueries += `&${key}=${queries[key]}`;
      }
    });
    push(value ? `?status=${value}${urlQueries}` : { urlQueries });
  };

  const onFilterSelect = (statusLabel, statusValue) => {
    updateUrl(statusValue);
    setFilteredStatus(statusLabel);
    onFilterTransactions({ status: statusValue });
  };

  const onClearFilter = () => {
    updateUrl();
    setFilteredStatus(null);
    onFilterTransactions({});
  };

  return (
    <>
      {filteredStatus && (
        <Label className="filter_transactions__tag">
          {filteredStatus}
          <Icon name="delete" onClick={onClearFilter} />
        </Label>
      )}
      <Dropdown
        floating
        closeOnBlur
        icon="filter"
        pointing="top left"
        className="button icon filter_transactions"
      >
        <Dropdown.Menu>
          <Dropdown.Menu scrolling>
            {toDropDownOptions(options || []).map(option => (
              <Dropdown.Item
                key={option.key}
                text={option.text}
                value={option.value}
                onClick={() =>
                  onFilterSelect(option.text, option.value)
                }
              />
            ))}
            <Divider />
            <Dropdown.Item
              text="Reset"
              className="reset"
              onClick={onClearFilter}
            />
          </Dropdown.Menu>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

FilterTransactions.defaultProps = {
  onFilterTransactions: null,
  options: ['pending', 'success', 'failed'],
};

FilterTransactions.propTypes = {
  onFilterTransactions: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.string),
};

export default FilterTransactions;
